













import { Component, Vue, Prop } from 'vue-property-decorator';
import Popup from '@/components/default/Popup.vue';
import { DxForm, DxSimpleItem, DxLabel, DxRequiredRule } from 'devextreme-vue/form';
import notificationService from '@/services/notificationService';


@Component({
    components: {
        DxForm,
        DxSimpleItem,
        DxLabel,
        DxRequiredRule,
        Popup,
    },
})
export default class MeasurementAddRoomPopup extends Vue {
    @Prop({required: true})
    private measurementName!: string;

    private model: { name: string } = {
        name: '',
    };
    private show: boolean = false;
    private saving: boolean = false;

    public open() {
        this.model.name = `${this.measurementName} - `;
        this.show = true;
    }

    get form() {
        const form: any = this.$refs.form;
        return form.instance;
    }

    private save() {
        const validationResult = this.form.validate();
        if (validationResult.isValid) {
            this.$emit('input', this.model.name );
            this.show = false;
            this.model.name = '';
        } else {
            notificationService.invalidForm();
        }
    }
}
